export default class CountdownTimer {
  /**
   * CountdownTimer class to manage a countdown timer.
   * @param {string} elementSelector - The selector for the HTML element to display the countdown.
   * @param {function} onComplete - Callback function to call when the countdown completes.
   * @param {number} duration - Duration of the countdown in milliseconds (default is 120000ms).
   */
  constructor(elementSelector, onComplete, { duration = 120000, label = ''} ) {
    this.duration = duration; // 2 minutes in milliseconds
    this.label = label;
    this.element = document.querySelector(elementSelector);
    this.onComplete = onComplete;
    this.rafId = null;
    this.startTime = Date.now();
  }

  /**
   * Starts the countdown timer.
   */
  start() {
    this.startTime = Date.now();
    this.update();
  }

  /**
   * Updates the countdown timer display.
   * This method is called recursively using requestAnimationFrame.
   */
  update = () => {
    const currentTime = Date.now();
    const elapsedTime = currentTime - this.startTime;
    const remainingTime = Math.max(0, this.duration - elapsedTime);

    if (remainingTime > 0) {
      if (this.element) {
        this.element.textContent = this.formatTime(remainingTime);
      }
      this.rafId = requestAnimationFrame(this.update);
    } else {
      if (this.element) {
        this.element.textContent = '0:00';
      }
      this.stop();
      if (this.onComplete) {
        this.onComplete();
      }
    }
  };

  /**
   * Stops the countdown timer.
   */
  stop() {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  /**
   * Formats the remaining time in milliseconds to a string in the format "MM:SS".
   * @param {Number} milliseconds - The remaining time in milliseconds.
   * @returns {string}
   */
  formatTime(milliseconds) {
    const totalSeconds = Math.ceil(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${this.label}${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
